<div class="stepper-wrapper">
    <div class="stepper-item">
        <div class="step-counter" (click)="goToStep(1)"></div>
        <div class="step-name stepName"><span>Problem type</span></div>
    </div>
    <div class="stepper-item">
        <div class="step-counter" (click)="goToStep(2)"></div>
        <div class="step-name stepName"><span>Location</span></div>
    </div>
    <div class="stepper-item">
        <div class="step-counter" (click)="goToStep(3)"></div>
        <div class="step-name stepName"><span>Further details</span></div>
    </div>
    <div class="stepper-item">
        <div class="step-counter" (click)="goToStep(4)"></div>
        <div class="step-name stepName"><span>Contact information</span></div>
    </div>
    <div class="stepper-item">
        <div class="step-counter" (click)="goToStep(5)"></div>
        <div class="step-name stepName"><span>Review</span></div>
    </div>
</div>